import axios from 'axios';
import { getCookie, setCookie } from './components/cookie/cookie';
import pubsub from './components/pubsub/pubsub';
import tippy from 'tippy.js';

import ToggleLink from './components/toggleLink/toggleLink';
import Megadrop from './components/megadrop/megadrop';
import MobileMenu from './components/mobileMenu/mobileMenu';
import MobileSearch from './components/mobileSearch/mobileSearch';
import InputSearch from './components/inputSearch/inputSearch';
import TabUsability from './components/tabUsability/tabUsability';
import EpiserverForm from './components/episerverForm/episerverForm';
import { wrap } from './components/utilities/utilities';
import AutoComplete from './libs/autocomplete';
import { handleChange } from './components/autoSubmit/autoSubmit';
import objectFitImages from 'object-fit-images';
import Flickity from 'flickity';
import psProfile from './components/psProfile/psProfile';
import psMessages from './components/psMessages/psMessages';
import psNews from './components/psNews/psNews';
import psCalendar from './components/psCalendar/psCalendar';
import 'flickity-imagesloaded';
import 'iframe-lightbox';
import './libs/pannellum';
import EduCart from './components/eduCart/eduCart';
import CaptureImage from './components/captureImage/captureImage';
import { initShowcase, hasShowcase, initShowcaseCarousel } from './components/showcase/showcase';
import ShowcaseList from './components/showcaseList/showcase-list'
import SplitImageSlider from './components/splitImageSlider/splitimageslider';
import ImageCarousel from './components/imageCarousel/imagecarousel';
import VideoBlock from './components/videoblock/videoblock';
import ShowcaseOverviewFilter from './components/showcaseOverviewFilter/showcaseoverviewfilter';
import ShowcaseOverview from './components/showcaseOverview/showcaseoverview';
import ShowcaseOverviewLink from './components/showcaseOverviewLink/showcase-overview-link'

/**
 * App
 * This starting point for this application.
 * @version 3.0.0
 * @exports App
 */
export default class App {
    constructor() {

        const docLang = document.documentElement.lang || 'sv';

        // sätt JQuery defaults
        jQuery.ajaxSetup({
            headers: {
                'Accept-Language': docLang, // gör att CultureInfo.CurrentUICulture sätts rätt även vid ajax-anrop!
                'X-Requested-With': 'XMLHttpRequest' // för att kunna avgöra om ett anrop är ett ajax-anrop
            }
        });

        // sätt axios defaults
        axios.defaults.headers.common['Accept-Language'] = docLang; // gör att CultureInfo.CurrentUICulture sätts rätt även vid ajax-anrop!
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'; // för att kunna avgöra om ett anrop är ett ajax-anrop

        // init tippy.js
        tippy('[data-tippy-content]', {
            theme: 'light-border',
            duration: 0,
            delay: [50, 50],
            touch: false
        });

        // Init menu
        new Megadrop();

        // Init mobile menu
        this.mobileMenu = new MobileMenu(document.querySelector('[data-type="mobileMenu"]'),
            {
                ajaxPath: mainConfig.menuAjaxPath,
                ajaxActivePane: mainConfig.menuAjaxActivePane,
                searchField: true,
                searchMethod: mainConfig.searchMethod,
                searchPage: mainConfig.searchPage,
                searchParameter: mainConfig.searchParameter,
                searchPlaceholder: mainConfig.searchPlaceholder,
            }
        );

        new MobileSearch(document.getElementById('mobile-search'), this.mobileMenu);

        new InputSearch(document.querySelector('[data-type="inputSearch"]'));

        document.querySelector('#headerQuickSearch button[type=submit]')?.addEventListener('click', event => {
            const headerForm = event.target.parentNode.form || event.target.form;
            if (headerForm && !headerForm.classList.contains('input-search__show')) {
                event.preventDefault();
                headerForm.classList.add("input-search__show");
                requestAnimationFrame(() => {
                    headerForm.querySelector('input[type="text"]')?.focus();
                });
            }
        });

        // Reset searchbar inputfält
        document.querySelector('.searchbar__reset')?.addEventListener('click', e => {
            e.preventDefault();
            const searchbarInput = document.getElementById('searchbar-input');
            if (searchbarInput?.value.length) {
                searchbarInput.value = '';
            }
        });

        // Init toggle link
        new ToggleLink();

        // Init tabUsability
        new TabUsability();

        // Utbildningskorgen
        new EduCart(document.querySelector('.educart__nav'));

        // Init table wrap for mobile scrolling of tables in rte.
        this._initRteTableWrap();

        // Init ajaxForm
        this._initAjaxForm();

        // Init episerverForms
        this._initEpiserverForm();

        // Init errorbar
        this._initErrorbar();

        // Init Flickity
        this._initFlickity();

        this._initPanorama();

        this._initExternalSearch();

        this._initAutocomplete();

        this._initFilterChips();

        this._initStickyHeader();

        this._initTruncation();

        this._initEducationChart();

        this._initLinkPuffs();

        // Framtidsbrevet
        this._initFutureLetter();

        // Utbildningssida film
        this._initEducationVideo();

        // Demo plugins (for demo purpose only, remove this when you build a new web).
        this._loadPluginsDemonstration();

        // Reload Page Upon Auth Expiration
        this._initAuthExpirationReload();

        this._initShowcaseLists();

        this._initSplitImageSliders();

        this._initImageCarousels();

        this._initVideoBlocks()

        this._initShowcaseOverview();

        this._initShowcaseOverviewFilter();

        this._initShowcaseOverviewLinks();

        this._initEducationCtaLink();

        for (const el of document.querySelectorAll('.iframe-lightbox-link')) {
            el.lightbox = new IframeLightbox(el);
        }

        objectFitImages();

        if (hasShowcase()) {
            initShowcase();
            initShowcaseCarousel();
            //initShowcaseKeyboardSupport(); ??
        }

        // PS
        new psProfile();

        if (document.getElementById('ps-messages')) {
            new psMessages(document.getElementById('ps-messages'));
        }
        if (document.getElementById('news-area')) {
            new psNews(document.getElementById('news-area'));
        }
        if (document.getElementById('psCalendarEvents')) {
            new psCalendar(document.getElementById('psCalendarEvents'));
        }

        // CookieBot
        document.addEventListener('CookiebotOnDialogDisplay', () => this._cookieBotScript());
        this._removeCookieBotTextContainer();
        const cookiebotPixImg = document.getElementById("CookiebotSessionPixel");
        if (cookiebotPixImg) {
            cookiebotPixImg.setAttribute("alt", "");
        }
        document.addEventListener("DOMContentLoaded", () => {
            this._cookieBotBlockIframes();
            this._removeDataCookieConsentFromIframe();
            this._adjustIframesForCookieInfo();
        });

        // CommonStandardBlock och ps-events clicks
        document.addEventListener("DOMContentLoaded", () => {
            for (const cls of ['.standard-block:not(.standard-block--link-list)', '.ps-calendar-list__event']) {
                if (!document.querySelector(cls)) {
                    continue;
                }

                document.addEventListener('click', e => {
                    const target = e.target;
                    if (target.matches(`${cls} *:not(a, a *)`) || window.getSelection().toString()) {
                        const block = target.closest('.standard-block');
                        if (block) {
                            e.preventDefault();
                            block.querySelector('.standard-block__content a')?.click();
                        }
                    }
                });
            }
        });

        document.addEventListener('DOMContentLoaded', () => {
            for (const block of document.querySelectorAll('.theme-un .standard-block')) {
                block.addEventListener('click', (e) => {
                    if (e.target.closest('a')) {
                        return;
                    }

                    e.stopPropagation();
                });
            }
        });
    }

    /**
     * Function that initiates the ajax-form functionality.
     * @private
     */
    _initAjaxForm() {
        const forms = document.querySelectorAll('[data-type="ajaxForm"]');
        if (forms.length) {
            import(/* webpackChunkName: "ajaxForm" */ './components/ajaxForm/ajaxForm')
                .then(AjaxForm => {
                    const attr = 'data-ajaxform-initiated';
                    for (const form of forms) {
                        if (!form.hasAttribute(attr)) {
                            new AjaxForm.default(form);
                            form.setAttribute(attr, true);
                        }
                    }
                });
        }
    }

    /**
     * Function that initiates the episerverform functionality.
     * @private
     */
    _initEpiserverForm() {
        const attr = 'data-episerverform-initiated';
        for (const form of document.querySelectorAll('[data-type="episerverForm"]')) {
            if (form.getAttribute(attr) !== 'true') {
                new EpiserverForm(form);
                form.setAttribute(attr, true);
            }
        }
    }

    /**
     * Function that wraps all tables in rte with a div to enable the scroll-feature in mobile.
     * @private
     */
    _initRteTableWrap() {
        for (const table of document.querySelectorAll('.rte table')) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('table-scrollable');
            wrap(table, wrapper);
        }
    }

    /**
     * Initiates errorbar with click event
     * @private
     */
    _initErrorbar() {
        const cookie = 'hbMsgAck';
        
        for (const errorBar of document.querySelectorAll('.error-bar')) {
            errorBar.querySelector('.btn--close')?.addEventListener('click', e => {
                e.preventDefault();
                let ids = getCookie(cookie)?.split('|') || [];
                ids.push(errorBar.getAttribute('data-error-id'));
                ids = [...new Set(ids)].filter(id => id.length > 0) // Rensar ev dubletter och tomma strängar
                setCookie(cookie, ids.join('|'), null, '/');
                errorBar.remove();
            });
        }
    }

    /**
     * Initiates carousels with Flickity
     * @private
     */
    _initFlickity() {

        const carouselNodes = document.querySelectorAll('.main-carousel');

        for (const carousel of carouselNodes) {
            const flkty = new Flickity(carousel, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                autoPlay: 5000,
                imagesLoaded: true,
                pauseAutoPlayOnHover: false,
                adaptiveHeight: true
            });

            const controlsWrapper = carousel.parentNode.querySelector('.carousel-controls');

            if (!controlsWrapper) {
                continue;
            }

            const fragment = document.createDocumentFragment();
            fragment.appendChild(carousel.querySelector('.flickity-page-dots'));
            controlsWrapper.appendChild(fragment);

            const pauseBtn = controlsWrapper.querySelector('.pause-play');
            let isPlaying = true;

            pauseBtn && pauseBtn.addEventListener('click', e => {
                e.preventDefault();

                if (isPlaying === true) {
                    flkty.pausePlayer();
                } else {
                    flkty.unpausePlayer();
                }

                isPlaying = !isPlaying;

                const iconSpan = pauseBtn.querySelector('.icon');
                iconSpan.classList.toggle('icon-pause', isPlaying);
                iconSpan.classList.toggle('icon-play', !isPlaying);
            });

            flkty.on('change', (index) => {
                for (const node of carouselNodes) {

                    const cell = node.querySelectorAll(".carousel-cell")[index];

                    if (cell) {
                        const wrapper = cell.closest('.image-header-with-description');
                        const descr = cell.querySelector('.image-header-with-description__description');
                        const slider = cell.closest(".image-header-slider");

                        if (wrapper && !descr) {
                            wrapper.classList.remove("image-header-with-description");
                        }
                        else if (slider && descr) {
                            slider.classList.add("image-header-with-description");
                        }
                    }
                }
            });

            const adjustViewportHeightWithCaption = () => {
                const selectedCell = document.querySelector('.flickity-slider .is-selected');
                const viewport = document.querySelector('.flickity-viewport');

                if (selectedCell && viewport) {
                    const image = selectedCell.querySelector('img');
                    const caption = selectedCell.querySelector('.image-header-with-description__description');

                    const imageHeight = image ? image.offsetHeight : 0;
                    const captionHeight = caption ? caption.offsetHeight : 0;
                    const totalHeight = imageHeight + captionHeight;

                    viewport.style.height = `${totalHeight}px`;
                }
            };

            flkty.on('ready', adjustViewportHeightWithCaption);
            flkty.on('select', adjustViewportHeightWithCaption);
            window.addEventListener('resize', adjustViewportHeightWithCaption);
        }

        // Education and ps sliders (availability fix)
        const wrapper = document.querySelector("#carousel-wrapper");

        if (wrapper) {
            const flkty = new Flickity("#carousel-wrapper", {
                cellAlign: 'center',
                contain: true,
                wrapAround: true,
                autoPlay: false,
                imagesLoaded: true,
                freeScroll: true,
                wrapAround: true,
                adaptiveHeight: true
            });

            const removeHiddenFn = (e) => {
                for (const cell of e.element.firstElementChild.children[0].children) {
                    cell.removeAttribute('aria-hidden');
                }
            }

            document.addEventListener('DOMContentLoaded', () => removeHiddenFn(flkty), { once: true });
            flkty.on('change', () => removeHiddenFn(flkty));
        }
    }

    /**
     * Initiates 360 panorama image block
     */
    _initPanorama() {
        for (const el of document.querySelectorAll('.panorama')) {
            pannellum.viewer(el, {
                type: el.getAttribute('data-type'),
                panorama: el.getAttribute('data-src'),
                autoLoad: el.getAttribute('data-autoload') === 'true' ? true : false,
            });
        }
    }

    /**
     * Initiates forms directed to external sites
     */
    _initExternalSearch() {
        const formElement = document.querySelector('[data-type="externalSearch"]');
        formElement?.addEventListener('submit', () => {
            const visibleQueryName = formElement.getAttribute('data-visible-query');
            const visibleQuery = formElement.querySelector(`[name="${visibleQueryName}"]`);
            const hiddenQueryName = formElement.getAttribute('data-hidden-query');
            const hiddenQuery = formElement.querySelector(`[name="${hiddenQueryName}"]`);
            hiddenQuery.value = hiddenQuery.value + visibleQuery.value;
        });
    }

    /**
     * Initiates autocomplete on searchbars
     */
    _initAutocomplete() {
        if (!(document.getElementById('searchbar-input')?.getAttribute('data-autocompleteUrl'))) {
            return;
        }

        new AutoComplete({
            selector: '#searchbar-input',
            source: (term, response) => {
                term = encodeURIComponent(term);
                const field = document.getElementById('searchbar-input');
                const url = field.getAttribute('data-autocompleteUrl');
                const name = field.getAttribute('name');

                axios({
                    url: `${url}?${name}=${term}`,
                    method: 'GET'
                })
                    .then(res => {
                        if (res.status === 200) {
                            if (res.data.suggestions.length > 0) {
                                response(res.data.suggestions);
                            }
                        } else {
                            alert('An error occured, try again later.');
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    });
            },
        });
    }

    /**
     * Initiates filterchips on searchbars
     */
    _initFilterChips() {
        const filterChips = document.getElementById('search-filterchips');

        if (!filterChips) {
            return;
        }

        const toggleFilterChips = () => {
            const filters = document.querySelectorAll('[data-type="autosubmit"]');
            let isChecked = false;
            filters.forEach(filter => {
                if (filter.checked === true) {
                    isChecked = true; // endast true om sista elementet är checked????
                }
            });

            if (isChecked) {
                filterChips.style.display = 'block';
            } else {
                filterChips.style.display = 'none';
            }
        };

        toggleFilterChips();

        document.addEventListener('click', e => {
            if (!e.target) {
                return false;
            }

            if (e.target.classList.contains('filterchip__remove')) {
                // Reset one filter
                const chipValue = e.target.value;
                for (const el of document.querySelectorAll('[data-type="autosubmit"]')) {
                    if (el.value === chipValue) {
                        switch (el.getAttribute('type')) {
                            case 'checkbox':
                                el.click();
                                break;
                            case 'radio':
                                el.removeAttribute('checked');
                                pubsub.publish('/ajaxForm/load');
                                break;
                        }
                    }
                }
            } else if (e.target.classList.contains('filterchip__reset-all')) {
                // Reset all filters
                e.preventDefault();
                for (const el of document.querySelectorAll('[data-type="autosubmit"]')) {
                    if (el.checked === true) {
                        switch (el.getAttribute('type')) {
                            case 'checkbox':
                                el.removeEventListener('change', handleChange);
                                el.click();
                                break;
                            case 'radio':
                                el.removeAttribute('checked');
                                break;
                        }
                    }
                }

                pubsub.publish('/ajaxForm/load');
            } else {
                return false;
            }
        });

        pubsub.subscribe('/ajaxForm/sync/updated', () => {
            toggleFilterChips();
        });
    }

    /**
     * Initiates sticky header
     */
    _initStickyHeader() {
        const header = document.querySelector('.page-header');
        window.addEventListener('scroll', e => {
            e.preventDefault;
            header.classList.toggle('shadow', window.scrollY > 0);
        });
    }

    /**
     * Initiates truncation of texts in standard-blocks
     */
    _initTruncation() {
        const standardBlocks = document.querySelectorAll('.standard-block__content--small');

        for (const block of standardBlocks) {
            const heading = block.querySelector('.standard-block__heading');
            const text = block.querySelector('.standard-block__text');

            if (!(heading && text)) {
                continue;
            }

            const dateLabel = block.querySelector('.standard-block__news .standard-block__label');
            const len = heading.innerText.length;
            let slice = 0;

            // One row
            if (len < 30) {
                if (dateLabel && 200 < text.innerHTML.length) {
                    slice = 200;
                }
            } else {
                let maxLen = 0;

                if (len < 60) {
                    maxLen = dateLabel ? 160 : 200;
                } else if (len < 80) {
                    maxLen = dateLabel ? 120 : 160;
                } else if (len < 120) {
                    maxLen = dateLabel ? 60 : 120;
                }

                if (maxLen > 0 && maxLen < text.innerHTML.length) {
                    slice = maxLen;
                }
            }

            if (slice > 0) {
                text.innerHTML = text.innerText.slice(0, slice) + '...';
            }
        }
    }

    /**
     * Loads all plugins
     * @private
     */
    _loadPluginsDemonstration() {
        if (document.querySelector('[data-type="loadMore"]')) {
            import(/* webpackChunkName: "loadMore" */ './components/loadMore/loadMore')
                .then(LoadMore => new LoadMore.default());
        }
        if (document.querySelector('[data-type="autosubmit"]')) {
            import(/* webpackChunkName: "autoSubmit" */ './components/autoSubmit/autoSubmit')
                .then(AutoSubmit => new AutoSubmit.default());
        }
    }

    /**
     * Inits charts
     * @private
     * */
    _initEducationChart() {
        const chart = document.querySelector('.education-chart .chart-canvas');
        if (chart) {
            import('./components/eduChart/eduChart')
                .then(EduChart => new EduChart.default(chart));
        }
    }

    _initLinkPuffs() {

        const blocks = document.querySelectorAll('.listing-puff-block');

        if (!blocks.length) {
            return;
        }

        const handler = (e) => {
            if (!e.target.matches('button.listing-puff-block__link')) {
                return;
            }

            const btn = e.target;
            const id = btn.getAttribute('data-id');
            const block = btn.closest('.listing-puff-block');

            // Rensa aktiva och sätt nuvarande som aktiv
            const cl = 'listing-puff-block__link__active';
            block.querySelectorAll('.' + cl).forEach(elem => elem.classList.remove(cl));
            btn.classList.add(cl);

            // Byt content
            for (const content of block.querySelectorAll('.listing-puff-block__right-content')) {
                content.toggleAttribute('hidden', content.getAttribute('data-id') !== id);
                content.classList.remove('listing-puff-block__right-content--default');
            }
        };

        // En event-hanterare per block istället för per puff-länk
        for (const block of blocks) {
            block.addEventListener('click', handler);
        }
    }

    _cookieBotScript() {
        const cookiebotBanner = document.getElementById("CybotCookiebotDialog");

        if (!cookiebotBanner || cookiebotBanner.hasAttribute('is-modified')) {
            return;
        }

        const heading = document.getElementById("CybotCookiebotDialogBodyContentTitle");
        if (heading) {
            heading.outerHTML = heading.outerHTML.replace(/h2/g, "p")
        }

        cookiebotBanner.setAttribute("role", "region");
        cookiebotBanner.removeAttribute('aria-modal');
        cookiebotBanner.toggleAttribute('is-modified', true);
    }

    _cookieBotBlockIframes() {
        if (this._isCookiebotScriptInHeader()) {
            // Hämta alla iframes inuti elementet med klassen "embed" och som har "data-cookieconsent" attribut
            let lang = document.documentElement.lang || 'sv';
            var iframes = document.querySelectorAll(".embed iframe[data-cookieconsent]");
            if (iframes.length > 0) {
                // Loopa igenom varje iframe ifall de är markerade med data-cookieconsent attribute.
                iframes.forEach(function (iframe) {
                    var categoryClasses = iframe.getAttribute("data-cookieconsent");

                    var categories = categoryClasses.split(',');
                    categories.forEach(function (category) {
                        category = category.trim();
                        var consentItem = iframe.parentElement.nextElementSibling;
                        if (consentItem && consentItem.classList.contains("cookieconsent-container")) {
                            consentItem.classList.add("cookieconsent-optout-" + category);

                            var cookieLink = consentItem.querySelector(".cookieconsent-container__link")
                            var cookieText;

                            switch (categoryClasses) {
                                case "preferences":
                                    cookieText = lang == "sv" ? "Acceptera inst&auml;llningar-cookies" : "Accept preferences-cookies";
                                    break;
                                case "marketing":
                                    cookieText = lang == "sv" ? "Acceptera marknadsf&ouml;rings-cookies" : "Accept marketing-cookies";
                                    break;
                                case "statistics":
                                    cookieText = lang == "sv" ? "Acceptera statistik-cookies" : "Accept static-cookies";
                                    break;
                                case "preferences,marketing":
                                    cookieText = lang == "sv" ? "Acceptera inst&auml;llningar och marknadsf&ouml;rings-cookies" : "Accept preferences and marketing-cookies";
                                    break;
                                default:
                                    cookieText = lang == "sv" ? "Acceptera dina cookies" : "Accept your cookies";
                                    break;
                            }
                            if (cookieLink) {
                                cookieLink.innerHTML = cookieText;
                            }
                        }
                    });
                });
            }
            else {
                //Dölj hjälptexten om cookiebot är inaktiverat.
                const consentItems = Array.from(document.querySelectorAll(".cookieconsent-container"));
                consentItems.forEach(element => element.style.display = 'none');
            }
        }
    }

    _adjustIframesForCookieInfo() {
        const iframes = document.querySelectorAll('iframe[data-cybot-cookiebot-blocked="true"]');
        if (iframes.length > 0) {
            iframes.forEach(function (iframe) {
                iframe.classList.remove('cookieconsent-optin-marketing');
                iframe.setAttribute('data-cybot-cookiebot-blocked', 'false');
            });
        }
    }

    _removeDataCookieConsentFromIframe() {
        if (!this._isCookiebotScriptInHeader()) {
            const iframeElements = document.querySelectorAll('iframe[data-cookieconsent]');
            iframeElements.forEach((iframe) => {
                iframe.removeAttribute('data-cookieconsent');
                const dataCookieblockSrc = iframe.getAttribute('data-cookieblock-src');
                if (dataCookieblockSrc) {
                    iframe.removeAttribute('data-cookieblock-src');
                    iframe.setAttribute('src', dataCookieblockSrc);
                }
            });
        }
    }

    _isCookiebotScriptInHeader() {
        const scriptElement = document.getElementById('Cookiebot');
        return !!scriptElement;
    }

    _removeCookieBotTextContainer() {
        if (!this._isCookiebotScriptInHeader()) {
            const acceptConsents = document.querySelectorAll('.cookieconsent-container');
            if (acceptConsents) {
                acceptConsents.forEach((item) => {
                    item.style.display = "none"
                });
            }
        }
    }

    /**
     * Init Framtidsbrevet
     */
    _initFutureLetter() {
        const form = document.querySelector('form.future-letter__form-container');

        form && document.addEventListener('DOMContentLoaded', () => {

            if (form.querySelector(".future-letter__capture-image-container")) {
                new CaptureImage().startup();
            }

            form.addEventListener('submit', event => {
                event.preventDefault();

                if (form.querySelectorAll('.input-validation-error').length) {
                    return;
                }

                const siteKey = document.body.dataset.recaptchaSiteKey || '';

                grecaptcha.ready(() => {
                    grecaptcha.execute(siteKey, { action: 'form_submit' })
                        .then(token => {
                            const input = form.querySelector("#Form_RecaptchaToken");
                            input && (input.value = token);
                            form.submit()
                        });
                })

            }, false);

        }, { once: true });
    }

    _initEducationVideo() {
        var videoContainer = document.querySelector(".full-video");
        var educationVideo = document.getElementById('education-video');
        // Play the video when the document is clicked

        if (videoContainer) {
            videoContainer.addEventListener('click', function (event) {
                // Check if the click target is the video element
                if (event.target == educationVideo) {
                    // Check if the video is paused
                    if (educationVideo.paused) {
                        // Play the video
                        educationVideo.play().catch(error => {
                            // Autoplay was prevented
                            console.error('Autoplay was prevented. Please interact with the page to start the video.');
                        });
                    }
                    else {
                        // Pause the video
                        educationVideo.pause();
                    }
                }
            });
        }

        //For Safari
        if (window.innerWidth < 768) {
            $('body').on('click touchstart', function () {
                var video = document.getElementById('education-video');
                if (video) {
                    if (!video.playing) {
                        video.play();
                    }
                }
            });
        }
    }

    _initAuthExpirationReload() {
        document.addEventListener("DOMContentLoaded", function () {
            var expirationAttr = document.body.getAttribute("data-auth-expiration");
            if (!expirationAttr) {
                return;
            }

            var sessionExpiration = new Date(expirationAttr);
            if (isNaN(sessionExpiration.getTime())) {
                return;
            }

            function checkExpiration() {
                if (new Date() >= sessionExpiration) {
                    window.location.reload();
                }
            }

            var timeUntilExpiration = sessionExpiration - new Date();
            if (timeUntilExpiration > 0) {
                setTimeout(checkExpiration, timeUntilExpiration);
            }
        });
    }

    _initShowcaseLists() {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.showcase-list-block__inner').forEach(container => {
                if (!container.getAttribute('data-carousel-loaded')) {
                    new ShowcaseList(container);
                }
            });
        });
    }

    _initSplitImageSliders() {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.split-image-slider').forEach((el) => {
                new SplitImageSlider(el);
            });
        });
    }

    _initImageCarousels() {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.image-carousel-block').forEach(container => {
                if (!container.getAttribute('data-carousel-loaded')) {
                    new ImageCarousel(container);
                }
            });
        });
    }

    _initVideoBlocks() {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.video-block').forEach((el) => {
                new VideoBlock(el);
            });
        });
    }

    _initShowcaseOverview() {
        document.addEventListener('DOMContentLoaded', () => {
            new ShowcaseOverview();
        });
    }

    _initShowcaseOverviewFilter() {
        document.addEventListener('DOMContentLoaded', () => {
            new ShowcaseOverviewFilter();
        });
    }

    _initShowcaseOverviewLinks() {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.showcase-overview-link-block__inner').forEach(container => {
                if (!container.getAttribute('data-carousel-loaded')) {
                    new ShowcaseOverviewLink(container);
                }
            });
        });
    }

    _initEducationCtaLink() {
        const link = document.getElementById('education-cta-link');
        if (!link) return;

        const isElementVisible = (el) => {
            if (!el) return false;
            if (el.hasAttribute('hidden')) return false;
            const style = window.getComputedStyle(el);
            if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
            const rect = el.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0;
        };

        const isImboxVisible = () => !!document.querySelector('#imbox-container');

        const update = () => {
            const path = (window.location.pathname || '').toLowerCase();

            const isEducationRoute =
                path === '/utbildning' ||
                path.startsWith('/utbildning/') ||
                path === '/en/international-student' ||
                path.startsWith('/en/international-student/');

            const shouldShow = isEducationRoute && !isImboxVisible();
            link.toggleAttribute('hidden', !shouldShow);
        };

        update();

        window.addEventListener('popstate', update);

        const patchHistory = (method) => {
            const original = history[method];
            history[method] = function (...args) {
                const ret = original.apply(this, args);
                window.dispatchEvent(new Event('locationchange'));
                return ret;
            };
        };

        patchHistory('pushState');
        patchHistory('replaceState');
        window.addEventListener('locationchange', update);

        const imboxRoot = document.querySelector('#imbox-container');
        if (imboxRoot) {
            const observer = new MutationObserver(() => update());
            observer.observe(imboxRoot, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'aria-expanded']
            });
        }
    }
}
